import MenuList from "../components/menu_list";
import { connect } from 'react-redux';

function mapStateToProps(state) {
  return {
    notificationList: state.notificationList
  };
}

export default connect(mapStateToProps)(MenuList);
